import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';

import { QrCodeValidationComponent } from './components/pages/qr-code-validation/qr-code-validation.component';
import { QrCodeGuard } from './guards/qr-code.guard';
import { QrCodeErrorComponent } from './components/pages/qr-code-error/qr-code-error.component';
import { QrCodeInvalidComponent } from './components/pages/qr-code-invalid/qr-code-invalid.component';

const routes: Routes = [
  {
    path: 'organizer.qr-code-validation.scanned/:id',
    component: QrCodeValidationComponent,
    canActivate: [QrCodeGuard],
  },
  {
    path: 'organizer.qr-code-validation.error',
    component: QrCodeErrorComponent,
    canActivate: [QrCodeGuard],
  },
  {
    path: 'organizer.qr-code-validation.invalid',
    component: QrCodeInvalidComponent,
    canActivate: [QrCodeGuard],
  },
];

/**
 * Prefix route of the sub modules
 */
@NgModule({
  imports: [
    RouterModule.forChild(routes),
    LocalizeRouterModule.forChild(routes),
  ],
  exports: [RouterModule, LocalizeRouterModule],
})
export class QrCodeValidationRoutingModule {}
